import React, {useState} from "react";
import logoheader from "@public/images/logo-isabelle-pivet.png";
import "../styles/Header.css";
import Navbar from './Navbar';
import { Menu, MenuItem } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";

const Header = () => {
  const [anchorEl, setAnchorEl] = React.useState<EventTarget | null>(null);
  const handleClick = (event: Event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <nav className="header">
      <div className="headerNavMobile">
        <Navbar />
        <img
          src="/images/logo-isabelle-pivet.png"
          alt='Carte de Visite Isabelle Pivet'
          style={{
                width: 80,
                height: 80,
                // borderRadius: 10,
              }}
        />
      </div>
      <div className="headerNav">
        <img
          src="/images/logo-isabelle-pivet.png"
          alt='Carte de Visite Isabelle Pivet'
          style={{
          width: 80,
          height: 80,
          // borderRadius: 10,
        }}
        />
        <div className="linkNav">
          <a href="/">
            <p>Accueil</p>
          </a>
        </div>
        <div className="linkNav">
          <a href="/domains" style={{display: "flex", flexDirection: "row"}}>
            <p style={{display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center"}}>
              Compétences
              {/* <ExpandMore style={{padding: 10}} onMouseEnter={handleClick} onClick={(e: Event) => handleClick(e)} /> */}
            </p>
          </a>
          <Menu
            id="simple-menu"
            // anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            // onExiting={handleClose}
            transitionDuration={500}
            style={{marginTop: 50, marginLeft: -120}}
          >
            <MenuItem onClick={handleClose}>
              <a href="/domain/commercial">Droit Commercial</a>
            </MenuItem>
            <MenuItem onClick={handleClose}>
              <a href="/domain/societes">Droit des Sociétés</a>
            </MenuItem>
            <MenuItem onClick={handleClose}><a href="/domain/family">Droit de la Famille</a></MenuItem>
            <MenuItem onClick={handleClose}><a href="/domain/penal">Droit Pénal</a></MenuItem>
            {/* <MenuItem onClick={handleClose}><a href="/domain/fiscality">Fiscalité des entreprises</a></MenuItem> */}
            <MenuItem onClick={handleClose}><a href="/domain/social">Droit Social</a></MenuItem>
          </Menu>
        </div>
        {/* <div className="linkNav">
          <a href="/honorary">
            <p>Honoraires</p>
          </a>
        </div> */}
        {/* <div className="linkNav">
          <a href="/mentions">
            <p>Mentions légales</p>
          </a>
        </div> */}
        <div className="linkNavContact">
          <a href="/contact">
            <p>Contacter Isabelle PIVET</p>
          </a>
        </div>
      </div>


    </nav>
  );
};

export default Header;
